import React from 'react';
import { Spinner as UniversalSpinner } from '@myddusfvs/ui-universal';

interface SpinnerProps {
  className?: string; // Kept for layout positioning via TailWind
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
  secondaryColor?: string;
}

/**
 * Spinner Component - Universal Migration Wrapper
 * Wraps @myddusfvs/ui-universal/Spinner to match legacy project API.
 */
const Spinner: React.FC<SpinnerProps> = ({ className, size = 'md', color, secondaryColor }) => {
  return (
    <div className={className} role="status" aria-live="polite">
      <UniversalSpinner
        size={size}
        color={color}
        secondaryColor={secondaryColor}
      />
    </div>
  );
};

export default Spinner;
